import { FC } from 'react';
import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
    DialogContent,
    DialogTitle,
    PriorityInfoDialogPaperProps,
    CloseButtonContainer,
    PriorityList,
    PriorityItem,
    PriorityLabel,
    PriorityRange
} from './styled';
import theme from 'src/theme';

interface Props {
    open: boolean;
    onClose: () => void;
}

const PriorityInfoModal: FC<Props> = ({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="priority-info-dialog-title"
            PaperProps={PriorityInfoDialogPaperProps}
        >
            <CloseButtonContainer>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: theme.color.white
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </CloseButtonContainer>
            <DialogTitle id="priority-info-dialog-title">
                Priority Scale
            </DialogTitle>
            <DialogContent>
                <PriorityList>
                    <PriorityItem>
                        <PriorityLabel>Low:</PriorityLabel>
                        <PriorityRange>1-3</PriorityRange>
                    </PriorityItem>
                    <PriorityItem>
                        <PriorityLabel>Medium:</PriorityLabel>
                        <PriorityRange>4-6</PriorityRange>
                    </PriorityItem>
                    <PriorityItem>
                        <PriorityLabel>High:</PriorityLabel>
                        <PriorityRange>7-9</PriorityRange>
                    </PriorityItem>
                    <PriorityItem>
                        <PriorityLabel>Urgent:</PriorityLabel>
                        <PriorityRange>10</PriorityRange>
                    </PriorityItem>
                </PriorityList>
            </DialogContent>
        </Dialog>
    );
};

export default PriorityInfoModal;
